/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


const productImageMap = {
  "7294959550615": {
    desktop: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Tsuya.jpg",
    mobile: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Tsuya_Mobile.jpg",
    link: "/products/kimono-tsuya-eau-de-toilette"
  },
  "5913583976599": {
    desktop: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Urara.jpg",
    mobile: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Urara_Mobile.jpg",
    link: "/products/kimono-urara-eau-de-toilette"
  },
  "5913566773399": {
    desktop: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Rin.jpg",
    mobile: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Rin_Mobile.jpg",
    link: "/products/kimono-rin-eau-de-toilette"
  },
  "5913514475671": {
    desktop: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Kihin.jpg",
    mobile: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Kihin_Mobile.jpg",
    link: "/products/decorte-kimono-kihin-eau-de-toilette"
  },
  "5913597640855": {
    desktop: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Yui.jpg",
    mobile: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Yui_Mobile.jpg",
    link: "/products/kimono-yui-eau-de-toilette"
  },
  "8335216672919": {
    desktop: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Hikari.jpg",
    mobile: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Hikari_Mobile.jpg",
    link: "/products/kimono-hikari-water-based-fragrance"
  },
  "8335184330903": {
    desktop: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Mai.jpg",
    mobile: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/Mai_Mobile.jpg",
    link: "/products/kimono-mai-water-based-fragrance"
  },
  "8076491948183": {
    desktop: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/AQ_Parfum.jpg",
    mobile: "https://cdn.shopify.com/s/files/1/0350/4095/2456/files/AQ_Mobile.jpg",
    link: "/products/aq-eau-de-parfum"
  }
};

const observer = new MutationObserver(() => {
  const productBlocks = document.querySelectorAll('[id^="quiz-kit-results-product-"]');
  console.log('test')

  productBlocks.forEach(block => {
    const fullId = block.getAttribute("data-product-id");
    if (!fullId) return;

    const productId = fullId.split("-").pop();
    const imageInfo = productImageMap[productId];
    if (!imageInfo) return;

    // Avoid duplicates
    if (block.querySelector("a[data-custom-image]")) return;

    const imageUrl = window.innerWidth <= 768 ? imageInfo.mobile : imageInfo.desktop;

    const link = document.createElement("a");
    link.href = imageInfo.link;
    link.target = "_blank";
    link.setAttribute("data-custom-image", "true");

    const img = document.createElement("img");
    img.src = imageUrl;
    img.alt = "Recommended Product Image";
    img.style.maxWidth = "100%";
    img.style.margin = "20px 0";

    link.appendChild(img);
    block.appendChild(link);
  });
});

document.addEventListener('quizKitResultsPageLoaded', function (e) {  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}, false);
